







































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { CustomersApi, LocationsApi } from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class LocationDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  customerId = null;
  locationId = null;
  customerOptions = [];
  locationOptions = [];

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  onCancel() {
    this.show = false;
    this.customerId = null;
    this.locationId = null;
  }

  onAdd() {
    const locationSelected = this.locationOptions.find(location => location.id === this.locationId);
    this.$emit("onAdd", locationSelected);
    this.onCancel();
  }

  async mounted() {
    this.initForm();
  }

  async initForm() {
    try {
      this.$util.showLoading();
      const customersRes = await new CustomersApi().getActiveCustomers();
      this.customerOptions = customersRes.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeCustomer() {
    this.locationOptions = [];
    this.locationId = null;
    if (!this.customerId) return;
    try {
      this.$util.showLoading();
      const res = await new LocationsApi().getLocationsActiveWithCustomer({
        customerId: this.customerId,
        status: 'Active',
      });
      this.locationOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  @Watch("customerId")
  onCustomerIdChanged(value: string, oldValue: string) {
    this.onChangeCustomer();
  }

  @Watch("show")
  onShowChanged(value: string, oldValue: string) {
    if (!value) this.onCancel();
  }

}
